var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ecc03e8c49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.472656 0.710938 L 21.539062 0.710938 L 21.539062 28.292969 L 8.472656 28.292969 Z M 8.472656 0.710938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ecc03e8c49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 18.507812 5.292969 L 21.515625 5.292969 L 21.515625 0.753906 L 17.675781 0.753906 L 17.675781 0.773438 C 12.625 0.957031 11.582031 3.785156 11.496094 6.777344 L 11.484375 6.777344 L 11.484375 9.925781 L 8.472656 9.925781 L 8.472656 14.46875 L 11.484375 14.46875 L 11.484375 28.273438 L 16.882812 28.273438 L 16.882812 14.46875 L 20.753906 14.46875 L 21.515625 9.925781 L 16.882812 9.925781 L 16.882812 7.109375 C 16.882812 6.105469 17.554688 5.292969 18.507812 5.292969 Z M 18.507812 5.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8a6cd539ee0a0e8ab916836ff9d56dc9.svg";
export { ForwardRef as ReactComponent };